import React from "react";
import { Box, Checkbox, Input, Text } from "@showitinc/showit-wc";
import HelpConstants from "../../../constants/HelpConstants";
import styles from "./SiteSettingsModal.module.css";
import { initFormatter } from "../../../utils/PropertyFormatters";

const GTM_ID = "gtmID";

const GoogleTagManager = ({ siteSettings, onChange }) => {
  const gtmId = siteSettings.getIn(["config", GTM_ID], "");
  const { onChange: _onChange } = initFormatter((propInfo) => {
    const trimmedPropInfo = { ...propInfo, value: propInfo.value.trim() };
    onChange(trimmedPropInfo);
  });
  return (
    <Box mb="3">
      <Box p="3">
        <Text variant="heading-1" className={styles.codeTitle}>
          Google Tag Manager
        </Text>
      </Box>
      <Box px="3" pb="3">
        <Text variant="small" variantStyle="light">
          Google Tag Manager is a free tool that allows you to add and manage tags on your site to
          track and optimize your marketing efforts.&nbsp;
          <a href={HelpConstants.GTM} target="_blank" rel="noreferrer">
            Learn More
          </a>
        </Text>
      </Box>
      <Box mb="2">
        <Input
          className={styles["text-field"]}
          bordered
          type="text"
          propName={`config.${GTM_ID}`}
          label="Google Tag Manager ID"
          value={gtmId}
          onSIInput={_onChange(`config.${GTM_ID}`)}
          onSIChange={_onChange(`config.${GTM_ID}`)}
          placeholder="GT/G/AW-XXXXXXXXX"
          longLabel
        />
      </Box>
      <Box d="flex" mb="2">
        <Checkbox
          className={styles.checkbox}
          checked={siteSettings.getIn(["config", "gtmSkipWP"], false)}
          label="Do not include on blog templates"
          onSIChange={(e) => onChange({ name: "config.gtmSkipWP", value: e.target.checked })}
        />
      </Box>
    </Box>
  );
};

export default GoogleTagManager;
